var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DataTable',{attrs:{"small":"","data":_vm.currentEncounterCarePlans,"columns":_vm.columns,"no-data-label":"No care plan is available"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('cv-data-table-cell',[_c('div',[_c('p',[_vm._v(_vm._s(row.description))])])])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }